import { useState, useEffect } from 'react';
import styled from 'styled-components';
import ProgressBar from './ProgressBar';
import OnboardingHeader from './OnboardingHeader';
import OnboardingSubheader from './OnboardingSubheader';
import { up } from 'styled-breakpoints';
import { useCookies } from 'react-cookie';
import FinalStep from './FinalStep';
import BusinessPage from './BusinessPage';
import UserRegistrationPage from './UserRegistrationPage';
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import MenuSetup from './MenuSetup';
import NotFound from './NotFound';
import { trackPageViewSegment } from '../utils/segmentUtils';
import PDFSetUp from "./PDFSetUp";
import VisualMenuBuilder from "./VisualMenuBuilder";
import VisualMenuPrompt from "./VisualMenuPrompt";
import MenuSelectionPage from "./MenuSelectionPage";
import MenuCreate from "./MenuCreate";
import MenuItemCreate from './MenuItemCreate';

const HeadingContainer = styled.div`
    margin-bottom: 2em;

    ${up('md')} {
        margin-bottom: 2.25em;
    }

    ${up('lg')} {
        margin-bottom: 2.5em;
    }

    ${up('xl')} {
        margin-bottom: 2.75em;
    }

    ${up('xxl')} {
        margin-bottom: 3em;
    }

    ${up('giant')} {
        margin-bottom: 4em;
    }

`;


function Onboarding() {
  const [header, setHeader] = useState("");
  const [subheader, setSubheader] = useState("");

  let location = useLocation();

  useEffect(() => {
    trackPageViewSegment(location.pathname, {
      title: document.title,
    });
  }, [location]);

  const [cookies] = useCookies(["placeId"]);

  const handleSetHeader = function (headerText) {
    setHeader(headerText);
  };

  const handleSetSubheader = function (subheaderText) {
    setSubheader(subheaderText);
  };

  return (
    <>
      <ProgressBar />
      <HeadingContainer>
        <OnboardingHeader text={header} />
        <OnboardingSubheader text={subheader} />
      </HeadingContainer>
      <Routes>
        <Route path="/">
          <Navigate to="get-started" />
        </Route>
        <Route path="get-started">
          {cookies.placeId ? (
            <Navigate to="/business-profile" />
          ) : (
            <UserRegistrationPage setHeader={handleSetHeader} setSubheader={handleSetSubheader} />
          )}
        </Route>
        <Route path="business-profile" element={<BusinessPage setHeader={handleSetHeader} setSubheader={handleSetSubheader} />} />
        <Route path="menu-builder">
          <Route element={<MenuSelectionPage setHeader={handleSetHeader} setSubheader={handleSetSubheader} />} />
          <Route path="pdf-initial" element={<PDFSetUp setHeader={handleSetHeader} setSubheader={handleSetSubheader} />}/>
          <Route path="visual-menu-choice" element={<VisualMenuPrompt setHeader={handleSetHeader} setSubheader={handleSetSubheader} />}/>
          <Route path="visual-menu" element={<VisualMenuBuilder setHeader={handleSetHeader} setSubheader={handleSetSubheader} />}>
            <Route path='create-menu' element={<MenuCreate />}/>
            <Route path='create-items' element={<MenuItemCreate />} />
          </Route>
          <Route path="pdf-menu" element={<PDFSetUp setHeader={handleSetHeader} setSubheader={handleSetSubheader} />}/>
        </Route>
        <Route path="finish" element={<FinalStep setHeader={handleSetHeader} setSubheader={handleSetSubheader} />}/>
        <Route>
          <NotFound />
        </Route>
      </Routes>
    </>
  );
}

export default Onboarding;
